<template>
  <div>
    <features>
      <template v-slot:header>
        <div>
          <h1 class="display-2 text-white font-weight-bold mb-0">
            Automated incident communication
          </h1>
          <h2 class="display-4 text-white font-weight-light">
            Reduce support tickets, increase user trust, and respond to
            incidents quicker than ever with a public status page.
          </h2>
          <p class="text-white mt-4">
            Effortlessly communicate incidents, latency issues and downtime to
            your customers - not only from your own services, but also services
            you depend on.
          </p>
        </div>
      </template>
      <template v-slot:hero-image>
        <b-img src="/img/public_status_page_comms.svg" />
      </template>
      <template v-slot:second>
        <b-col md="6">
          <h2 class="display-3 text-white" style="font-weight: 600;">
            Public status pages lead to a
            <span class="text-success" style="font-weight: 600;">
              67% increase in customer trust.
            </span>
          </h2>
          <p class="lead text-white mb-6">
            Always keep your users in the know. With automated uptime and
            incident monitoring, your users will never be left guessing when it
            comes to your services.
          </p>
        </b-col>
      </template>

      <template v-slot:feature-breakdown>
        <section class="py-6">
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2 features-col">
                <b-img src="/img/issue.svg" fluid />
              </b-col>
              <b-col md="6" class="col-md-6">
                <div class="pr-md-5">
                  <h1>Keep Your Users Informed</h1>
                  <p>
                    Your users can subscribe to your status page, getting
                    notified every time an incident occurs. We have a robust
                    notification system to avoid false alarms and only notify
                    when something is truly wrong.
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>

        <section class="py-6">
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="justify-content-center features-col">
                <b-img src="/img/design.svg" />
              </b-col>
              <b-col md="6">
                <div class="pr-md-5">
                  <h1>Powerful Design Customization</h1>
                  <p>
                    Make your status page your own by customizing it entirely.
                    Match the feel of your own website and include your own
                    custom branding.
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>

        <section class="py-6">
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2 features-col">
                <b-img src="/img/github.svg" fluid />
              </b-col>
              <b-col md="6" class="col-md-6">
                <div class="pr-md-5">
                  <h1>
                    Incidents from Third-Party Services
                  </h1>
                  <p>
                    BoltScale integrates with the status pages of hundreds of
                    third-party services, such as
                    <a target="blank" href="https://www.githubstatus.com/#">
                      GitHub
                    </a>
                    ,
                    <a target="blank" href="https://status.digitalocean.com/">
                      Digital Ocean
                    </a>
                    , and
                    <a target="blank" href="https://status.sendgrid.com/">
                      SendGrid
                    </a>
                    . Display the status of these services on your status page,
                    and automatically get updates when one of these services
                    declare an issue.
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
      </template>
    </features>
  </div>
</template>

<script>
import Features from "@/views/Pages/Features/Features";

//import { Tooltip } from "element-ui";
export default {
  name: "why-boltscale",
  components: {
    Features
  }
};
</script>

<style>
.iphone-hero-img {
  height: 300px;
  width: auto;
}
.card-snippet {
  text-align: center;
}
.main-content {
  overflow: hidden;
}

.features-col {
  text-align: center;
}

.features-col img {
  max-width: 300px;
}

.hero-image {
  margin-top: 25px;
  width: 800px;
  margin-bottom: -94px;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  /*box-shadow: 1px 1px 100px 51px rgba(25, 43, 77, 0.1);*/
}
</style>
